"use client";

import { c as _c } from "react/compiler-runtime";
import { Bell } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/ui/shadcn/button";
import { AvailabilityNotificationPanel } from "./availability-notification-panel";
export const AvailabilityNotificationButton = t0 => {
  const $ = _c(16);
  const {
    product,
    selectedVariant,
    isOutOfStock,
    domain,
    storeBaseUrl,
    className
  } = t0;
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  if (!isOutOfStock || !selectedVariant) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsPanelOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = cn("flex items-center justify-center gap-2 h-10 px-4 py-2", "bg-neutral-100 hover:bg-neutral-200 text-neutral-900", "border border-neutral-300 rounded-md font-medium", "transition-colors duration-200", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Bell className="h-4 w-4" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Button onClick={t1} className={t2}>{t3}Restock Alert</Button>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsPanelOpen(false);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== domain || $[8] !== isPanelOpen || $[9] !== product || $[10] !== selectedVariant || $[11] !== storeBaseUrl) {
    t6 = <AvailabilityNotificationPanel isOpen={isPanelOpen} onClose={t5} product={product} selectedVariant={selectedVariant} domain={domain} storeBaseUrl={storeBaseUrl} />;
    $[7] = domain;
    $[8] = isPanelOpen;
    $[9] = product;
    $[10] = selectedVariant;
    $[11] = storeBaseUrl;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};